import { render, staticRenderFns } from "./StudentStaffAdmin.vue?vue&type=template&id=dcce474a"
import script from "./StudentStaffAdmin.vue?vue&type=script&lang=js"
export * from "./StudentStaffAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports